import React, { useRef } from 'react'
import { Modal, ModalBody } from 'reactstrap'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const styles = require('./SelectTemplate.styles.scss')

interface CommonProps {
  visible: boolean
  onClose: () => void
  onSelect: () => void
}

export default function SelectTemplateModal(props: CommonProps) {
  const { visible } = props

  const iframeRef = useRef<HTMLIFrameElement>(null)
  const iframeUrl = `/composer/templates/v2/author`

  const handleCancel = () => {
    setTimeout(() => {
      props.onClose()
    }, 100)
  }

  return (
    <Modal
      wrapClassName="bootstrap4"
      className={styles.root}
      isOpen={visible}
      toggle={handleCancel}
    >
      <ModalBody>
        <button
          className="close"
          onClick={handleCancel}
          data-testid="close-select-template-modal"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.53265 8.11789C9.5013 8.08662 9.48369 8.04416 9.48369 7.99989C9.48369 7.95562 9.5013 7.91316 9.53265 7.8819L15.7075 1.70749C16.0979 1.31648 16.0975 0.682993 15.7065 0.292544C15.3155 -0.0979049 14.682 -0.0974572 14.2916 0.293544L8.11743 6.46529C8.08617 6.49663 8.04371 6.51425 7.99944 6.51425C7.95517 6.51425 7.91272 6.49663 7.88145 6.46529L1.7073 0.293544C1.31687 -0.0970891 0.6837 -0.0972383 0.293083 0.293211C-0.0975338 0.68366 -0.097683 1.31685 0.29275 1.70749L6.46624 7.8819C6.49758 7.91316 6.5152 7.95562 6.5152 7.99989C6.5152 8.04416 6.49758 8.08662 6.46624 8.11789L0.29275 14.293C0.040184 14.5457 -0.0583906 14.9139 0.034158 15.259C0.126707 15.6041 0.396318 15.8736 0.741433 15.966C1.08655 16.0584 1.45473 15.9596 1.7073 15.7069L7.88145 9.53183C7.91272 9.50048 7.95517 9.48287 7.99944 9.48287C8.04371 9.48287 8.08617 9.50048 8.11743 9.53183L14.2916 15.7069C14.682 16.0975 15.3152 16.0977 15.7058 15.7072C16.0964 15.3168 16.0966 14.6836 15.7061 14.293L9.53265 8.11789Z"
              fill="#363A53"
            />
          </svg>
        </button>
        <iframe
          id="templateSelector"
          ref={iframeRef}
          title="SelectTemplate Selector"
          height="100%"
          width="100%"
          src={iframeUrl}
        />
      </ModalBody>
    </Modal>
  )
}
